import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import AdminList from './AdminList'
import { filterRelationshipManagers, filterAccountManagers, filterLendingManagers } from './helpers/adminRoleFilters'
import administratorType from '../common/types/administratorType'

const CardBody = styled.div`
  padding: 25px 40px;
`
const SectionTitle = styled.h2`
  font-size: 17px;
  font-weight: 600;
  line-height: 28px;
`

const PodCardBody = ({ admins }) => {
  const relationshipManagers = filterRelationshipManagers(admins)
  const accountManagers = filterAccountManagers(admins)
  const lendingManagers = filterLendingManagers(admins)
  return (
    <CardBody>
      <SectionTitle>
        Lending Managers
      </SectionTitle>
      <AdminList admins={lendingManagers} />
      <SectionTitle>
        Account Managers
      </SectionTitle>
      <AdminList admins={accountManagers} />
      <SectionTitle>
        Relationship Managers
      </SectionTitle>
      <AdminList admins={relationshipManagers} />
    </CardBody>
  )
}

PodCardBody.propTypes = {
  admins: PropTypes.arrayOf(administratorType)
}

export default PodCardBody
